import { axios } from 'lib/axios'
import { useMutation } from 'react-query'

type FinderApiAddress = {
  address: string
  district: string
  zipCode: string
  number: string
  state: string
  city: string
  country: string
  complement: string
}

type FinderApiResponse = {
  shortName: string
  fullName: string
  phone: string
  stateRegistration: string
  address: FinderApiAddress
}

type Response = {
  registration: string
  name: string
  shortName: string
  birthDate: string
  phone: string
  email: string
  address: {
    lineOne: string
    number: string
    complement: string
    city: string
    state: string
    zipCode: string
    district: string
  }
}

const mapFinderToResponse = (data: FinderApiResponse): Response => {
  const { address } = data

  return {
    registration: data.stateRegistration ?? '',
    name: data.fullName ?? '',
    shortName: data.shortName ?? '',
    birthDate: '',
    phone: data.phone ?? '',
    email: '',
    address: {
      lineOne: address?.address ?? '',
      number: address?.number ?? '',
      complement: address?.complement ?? '',
      city: address?.city ?? '',
      state: address?.state ?? '',
      zipCode: address?.zipCode ?? '',
      district: address?.district ?? ''
    }
  }
}

const fetcher = async (cnpj: string): Promise<Response> => {
  const normalizedCnpj = cnpj.replace(/\D/g, '')

  const data = await axios.get<any, FinderApiResponse>(
    `/customers/cnpj-lookup/${normalizedCnpj}`
  )

  return mapFinderToResponse(data)
}

export const useLoadCustomerRegistrationByCnpj = () => {
  return useMutation(fetcher, {
    onError: (error: unknown) => {
      console.log(error)
    }
  })
}
